export const getBrowserDefaultLanguage = (): string => {
    const lang = navigator.language.substring(0, 2);
    return lang;
};
